import React from "react";
import { TenoreLogo } from "./TenoreLogo";

interface SectionHeaderProps {
  title: string;
  className?: string;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  className = "",
}) => {
  return (
    <div
      className={`flex flex-col gap-2 items-center text-center pt-3 pb-10 [text-shadow:0_2px_30px_rgba(0,0,0,.3)] ${className}`}
    >
      <TenoreLogo className="text-white dark:text-white mr-1.5" />
      <h1 className="text-lg font-light text-white uppercase tracking-[.25em]">
        {title}
      </h1>
    </div>
  );
};
